import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getFeatureFlags = createAsyncThunk('getFeatureFlags', async () => {
    const response = await axios.get(`/feature-flags`);

    return response?.data;
});
